import { walletDetailsMap } from 'maps/walletMaps/walletMaps';

/**
 * Retrieves the formatted details for a wallet payment method.
 *
 * Looks up the wallet type in walletDetailsMap and invokes the corresponding function
 * to get the details. Returns an empty string if the wallet type is not supported.
 *
 * @param wallet The wallet payment method object.
 * @returns {string} The formatted wallet details string, or an empty string if not applicable.
 */
export const getWalletDetails = wallet =>
  walletDetailsMap[wallet?.walletType]?.(wallet) ?? '';
